const { addIndex, map } = require("ramda")

const vehicleCategory = [
  "Motorcycle | Tricycle",
  "Saloon Car-Midi (1.4-1.9L) e.g. Picanto, Corolla, Almera, Civic",
  "Saloon Car-Maxi (2.0-2.6L) e.g. Camry, Benz, Accord, Lexus & Others",
  "SUV | Jeep | Bus | Pick-Up | Crossover",
  "Coaster Bus",
  "Mini Trucks | Trucks 15 Tons (Tippers)",
  "Trucks 20 Tons (6-10 Tyres)",
  "Trucks 30 Tons (Trailers 10+ Tyres)",
]

const vehicleCategoryDropdown = addIndex(map)((label, index) => ({
  label,
  value: index + 1,
}))(vehicleCategory)

const typeOfDocOnVehicle = [
  "Individual Name Only",
  "Individual & Company Name",
  "Company Name Only",
]
const typeOfDocOnVehicleDropdown = [
  { label: "Individual Name Only", value: "private" },
  { label: "Individual & Company Name", value: "commercial" },
  { label: "Company Name Only", value: "commercial" },
]

const typeOfPlateOnVehicle = [
  "regular",
  "regular-custom-lg",
  "commercial-red-plate",
  "custom",
]
const typeOfPlateOnVehicleDropDown = [
  { label: "Regular", value: "regular" },
  { label: "Regular (with preferred Local Govt.)", value: "regular-custom-lg" },
  { label: "Commercial (Red plate)", value: "commercial-red-plate" },
  { label: "Custom", value: "custom" },
]

const typeOfPlateRenderLabels = [
  { value: "regular", label: "Regular" },
  {
    value: "regular-custom-lg",
    label: "Regular with Custom Local Govt.",
  },
  { value: "commercial-red-plate", label: "Commercial - Red Plate" },
  { value: "custom", label: "Customized plate" },
]

const formatTypeOfPlateLabel = (typeOfPlate) => {
  const match = typeOfPlateRenderLabels.find((item) => item.value === typeOfPlate)
  return match?.label || typeOfPlate
}

module.exports = {
  vehicleCategory,
  vehicleCategoryDropdown,
  typeOfDocOnVehicle,
  typeOfDocOnVehicleDropdown,
  typeOfPlateOnVehicle,
  typeOfPlateOnVehicleDropDown,
  typeOfPlateRenderLabels,
  formatTypeOfPlateLabel,
}
